const FEATURES = [
  {
    icon: 'ri-stack-fill',
    title: '海量漫画资源',
    desc: '收录超过50000部韩漫、日漫、国漫作品，涵盖热血、恋爱、奇幻、悬疑、搞笑等全部热门类型，总有你喜欢的。',
  },
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式流畅阅读',
    desc: '专为移动端和网页端优化的下拉式阅读模式，无需点击翻页，向下滑动即可无缝衔接下一话，沉浸感十足。',
  },
  {
    icon: 'ri-flashlight-fill',
    title: '每日稳定更新',
    desc: '编辑团队每日追踪热门连载，确保超过200部作品同步更新，追更党不用苦等，热门漫画第一时间送达。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-2">
          本站优势
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          为什么数百万读者选择歪歪漫画网
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {FEATURES.map((feat) => (
            <div
              key={feat.title}
              className="bg-background-50 rounded-xl p-6 md:p-8 text-center group hover:-translate-y-1 transition-all cursor-default"
            >
              <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-500">
                <i className={`${feat.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold font-heading text-foreground-900 mb-3">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}